import localFont from 'next/font/local'
import { Inter, Geist_Mono } from 'next/font/google'

export const satoshi = localFont({
  src: [{ path: '../../public/fonts/Satoshi-Bold.woff2', weight: '700', style: 'normal' }],
  variable: '--font-satoshi',
  display: 'swap',
  adjustFontFallback: 'Arial',
  // preload: true, // better UX, worse LCP
  preload: false, // worse UX, better LCP
})

export const satoshiRegular = localFont({
  src: [{ path: '../../public/fonts/Satoshi-Regular.woff2', weight: '400', style: 'normal' }],
  variable: '--font-satoshi-regular',
  display: 'swap',
  preload: false,
})

export const inter = Inter({
  subsets: ['latin'],
  variable: '--font-inter',
  display: 'swap',
  preload: false,
})

// Geist Mono is only used in below-the-fold ranking-number badges. It does NOT
// participate in initial fontVariables — instead, GeistMonoActivator (mounted
// in the app layout) adds geistMono.variable to <html> after the user's first
// interaction. Until then, .font-mono falls back to the system mono stack via
// the tailwind config. This eliminates the 2.4s critical-path font load that
// Lighthouse was flagging without removing Geist Mono from the design.
export const geistMono = Geist_Mono({
  subsets: ['latin'],
  variable: '--font-geist-mono',
  display: 'swap',
  preload: false,
})

export const fontVariables = `${inter.variable} ${satoshi.variable} ${satoshiRegular.variable}`
